/**
 * The active lottery, published by `LotteryLayout` once `GET /v1/l/:slug` resolves and read by the providers
 * that sit ABOVE the router (IntlProvider locale/timeZone/currency, MotionProvider lotteryCalm). A tiny
 * external store keeps the provider order of docs/modules/web.md without prop-drilling through the router.
 */
import { useSyncExternalStore } from 'react';
import type { PublicLotteryDto } from '@windrop/contracts';

type Listener = () => void;
let active: PublicLotteryDto | null = null;
const listeners = new Set<Listener>();

export function setActiveLottery(next: PublicLotteryDto | null): void {
  if (active === next) return;
  active = next;
  for (const l of listeners) l();
}

export function getActiveLottery(): PublicLotteryDto | null {
  return active;
}

const subscribe = (l: Listener) => {
  listeners.add(l);
  return () => {
    listeners.delete(l);
  };
};

export function useActiveLottery(): PublicLotteryDto | null {
  return useSyncExternalStore(subscribe, getActiveLottery, getActiveLottery);
}
